module.exports = __webpack_public_path__ + "static/media/How you can create follow-up invoice for Stagewise Templated invoices.bf3ed055.png";